import React from 'react';
import {Link} from 'react-router-dom';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


export default () => (
  <Row className="main-nav">
    <Col className="close">
      <Link to="/">×</Link>
    </Col>
    <Col >
      <Link to="/about">About</Link>
    </Col>
    <Col >
        <Link to="/resources">Further resources</Link>
    </Col>
    <Col >
        <Link to="/terms">Terms & Definitions</Link>
    </Col>
    {/*
    <Col >
        <Link to="/#" className="button-nav-item">Download Report</Link>
    </Col>
    */}
  </Row>
);



// WEBPACK FOOTER //
// ./src/components/navigation.js